import styled from 'styled-components'

import Icon from '../Icon'
import ActionButton from '../ActionButton'

export const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
`
export const AddMemberButton = styled(ActionButton)`
  margin: 1rem 0 2rem 0;
`

export const Member = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`

export const MemberInfo = styled.div`
  ${({ theme }) => theme.textStyles.textLargeStrong}
  color: ${({ theme }) => theme.colors.nightRider};
`

export const StyledIcon = styled(Icon)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.neonBlue};
`

export const StyledActionButton = styled(ActionButton)`
  margin-left: 1rem;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`
